<template>
	<div v-show="show">
		<vx-card>
			<vs-row v-if="skillCreatePermission">
				<div class="vx-col w-full mb-base">
					<div class="flex justify-between flex-wrap">
						<SkillsForm :data="skillItem" :isEditActive="false" />
					</div>
				</div>
			</vs-row>
			<not-permission v-else></not-permission>
		</vx-card>
	</div>
</template>
<script>
import SkillsForm from "@/components/skills/SkillsForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "CreateSkill",
	components: {
		SkillsForm,
		NotPermission,
	},
	data() {
		return {
			skillItem: {},
			show: false,
		};
	},
	computed: {
		skillCreatePermission() {
			return this.$store.getters.checkPermission("SKILLS_C");
		},
	},
	mounted() {
		this.show = true;
	},
};
</script>
